/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    request = request.clone({
      withCredentials: true,
    });

    const groupId = window.localStorage.getItem('groupId');
    if (groupId) {
      request = request.clone({
        setHeaders: {
          groupid: groupId,
        },
      });
    }

    return next.handle(request);
  }
}
